import qs from 'qs';
import {
  $reportsFilters,
  GetEventReportsFilters,
} from '@loyalty/shared-common/event-processing-api-client';
import { joiOptions } from '@loyalty/shared-common';
import { isInShell } from '../../libs/shell/shell';

const defaultFilters: GetEventReportsFilters = {
  statuses: [],
  programIds: [],
  sources: [],
  eventNames: [],
  startDate: undefined,
  endDate: undefined,
  isTestUser: undefined,
  identity: undefined,
  clientEventId: undefined,
  profileId: undefined,
  limit: 10,
};

function getISOString(date: any): string | undefined {
  try {
    return date.toISOString();
  } catch {
    return undefined;
  }
}

export function saveFiltersToQuery(filters: GetEventReportsFilters): void {
  const params = {
    ...defaultFilters,
    ...filters,
    startDate: getISOString(filters.startDate),
    endDate: getISOString(filters.endDate),
  };
  const q = qs.stringify(params, { addQueryPrefix: true });
  const w = isInShell() ? window.parent : window;
  w.history.pushState(null, '', w.location.origin + w.location.pathname + q);
}

export function getFiltersFromUrl(): GetEventReportsFilters | undefined {
  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const { error, value } = $reportsFilters.validate(query, joiOptions);
  return !error ? { ...defaultFilters, ...value } : undefined;
}
